
import { apiSlice } from '../../../api/apiSlice';
import * as constants from '../../../constants';

export const aboutMeSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getAboutMePersonalization: builder.query({
            query: (arg: any) => {
                const { employeeNumber } = arg;
                return {
                    url: constants.ABOUT_ME_PERSONALIZATION,
                    params: { employeeNumber },
                };
            },
        }),
        createUpdateAboutMe: builder.mutation({
            query: (arg: any) => ({
                url: constants.CREATE_UPDATE_ABOUT_ME_PERSONALIZATION,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
        }),
    }),
});

export const {
    useGetAboutMePersonalizationQuery,
    useCreateUpdateAboutMeMutation,
} = aboutMeSlice;
